export default __webpack_public_path__ + "assets/images/b932811ee7698ed4a3d6870cea1f3f43.svg";